import SeoKeywordList from './SeoKeywordList.container';

export default SeoKeywordList;
